import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {FormResponse, FormResponseAttachmentInput} from './form-response.model';

export const loadFormResponses = createAction(
  '[FormResponse/API] Load FormResponses',
  props<{ formResponses: FormResponse[] }>()
);

export const addFormResponse = createAction(
  '[FormResponse/API] Add FormResponse',
  props<{ formResponse: FormResponse }>()
);

export const upsertFormResponse = createAction(
  '[FormResponse/API] Upsert FormResponse',
  props<{ formResponse: FormResponse }>()
);

export const addFormResponses = createAction(
  '[FormResponse/API] Add FormResponses',
  props<{ formResponses: FormResponse[] }>()
);

export const upsertFormResponses = createAction(
  '[FormResponse/API] Upsert FormResponses',
  props<{ formResponses: FormResponse[] }>()
);

export const updateFormResponse = createAction(
  '[FormResponse/API] Update FormResponse',
  props<{ formResponse: Update<FormResponse> }>()
);

export const updateFormResponses = createAction(
  '[FormResponse/API] Update FormResponses',
  props<{ formResponses: Update<FormResponse>[] }>()
);

export const deleteFormResponse = createAction(
  '[FormResponse/API] Delete FormResponse',
  props<{ id: string }>()
);

export const deleteFormResponses = createAction(
  '[FormResponse/API] Delete FormResponses',
  props<{ ids: string[] }>()
);

export const clearFormResponses = createAction(
  '[FormResponse/API] Clear FormResponses'
);

// CUSTOM
export const citizenGetFormResponses = createAction(
  '[FormResponse/API] citizen get FormResponses',
  props<{  pageNumber?: number, itemsPerPage?: number,serviceUniqueId?: string }>()
);

export const getFormResponses = createAction(
  '[FormResponse/API] get FormResponses',
  props<{ requestType?: string,  pageNumber?: number, itemsPerPage?: number, serviceUniqueId?: string, responseUniqueId?: string, fewFields?: boolean;}>()
);

export const closeRequest = createAction(
  '[FormResponse/API] close FormRequest',
  props<{
    requestUniqueId?: string;
    attachments?: FormResponseAttachmentInput[];
    comment?: string
  }>()
);
